import type { BrandedJobProctorData } from "../utils/employerUtils";

import { useViewjobProctorAllocation } from "../../proctor/__generated__/ViewjobProctorContext";
import { BrandedjobMigrationRnvjTst } from "../../proctor/__generated__/ViewjobProctorSpecifications";

import { useMemo } from "react";

export function useBrandedJobProctorData(): BrandedJobProctorData & {
  shouldQueryBrandingEligibility: boolean;
} {
  const brandedJobRnvjAllocation = useViewjobProctorAllocation(BrandedjobMigrationRnvjTst).value;

  return useMemo(
    () => ({
      isBrandedJobMigrationTestActive: brandedJobRnvjAllocation === 1,
      isBrandedJobMigrationShadow: brandedJobRnvjAllocation === 2,
      shouldQueryBrandingEligibility: brandedJobRnvjAllocation > 0,
    }),
    [brandedJobRnvjAllocation],
  );
}
